import React, { useState, useEffect } from "react";
import { Accessibility } from 'lucide-react';

const basePath = import.meta.env.VITE_BASE_PATH || '';

export default function AccessibilityWidgetButton() {
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const accessibilityWidgetIconConfig = {
    display: false,
    useEmojis: true,
    position: {
      bottom: { size: 0 },
      left: { size: 0 },
      type: 'none'
    }
  }

  useEffect(() => {
    // Check screen size on mount and on resize
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth > 1024);
    };

    // Initial check
    checkScreenSize();

    // Add event listener for resize
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  useEffect(() => {
    if (!isLargeScreen) return;

    let widgetInstance = null;
    
    // Inject CSS to hide the default accessibility icon
    const hideIconStyle = document.createElement('style');
    hideIconStyle.id = 'hide-accessibility-icon';
    hideIconStyle.textContent = `
      ._access-icon {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        width: 0 !important;
        height: 0 !important;
      }
    `;
    if (!document.getElementById('hide-accessibility-icon')) {
      document.head.appendChild(hideIconStyle);
    }
    
    function cleanupWidget() {
      if (window.document.querySelector("._access-menu")) {
        window.document.querySelector("._access-menu ._menu-close-btn")?.click();
        setTimeout(() => {
          window.document.querySelector("._access-menu")?.remove();
          window.document.querySelector("._access-icon")?.remove();
        }, 500);
      }
    }

    if (!document.getElementById("accessibility-widget-script")) {
      const script = document.createElement("script");
      script.id = "accessibility-widget-script";
      script.src = `${basePath}/accessibility.bundle.js`;
      script.async = true;
      script.onload = () => {
        if (window.Accessibility) {
          widgetInstance = new window.Accessibility({
            textToSpeechLang: "en-US",
            speechToTextLang: "en-US",
            icon: accessibilityWidgetIconConfig
          });
        }
      };
      document.body.appendChild(script);
    } else if (window.Accessibility) {
      widgetInstance = new window.Accessibility({
        textToSpeechLang: "en-US",
        speechToTextLang: "en-US",
        icon: accessibilityWidgetIconConfig
      });
    }

    return () => {
      cleanupWidget();
    };
  }, [isLargeScreen]);

  const handleClick = () => {
    if (window.Accessibility) {
      const menuButton = window.document.querySelector("._access-icon");
      if (menuButton) {
        menuButton.click();
      }
    }
  };

  return (
    <button
      onClick={handleClick}
      className="w-12 h-12 bg-[#383838] rounded-full shadow-lg flex items-center justify-center hover:bg-gray-300 transition-colors"
      aria-label="Accessibility Options"
    >
      <Accessibility className="w-6 h-6 text-white " />
    </button>
  );
}